module.exports = __webpack_public_path__ + "images/footer/saubere_filme_footer_foto.jpg";